import { Component,Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { UserProfile, UserRoleTypes } from 'src/app/web-api-client';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent {
 @Input() user: UserProfile;

 public profileImg: 'assets/images/dashboard/profile.jpg' | any;

  constructor(public router: Router,public authService:AuthService) {}

  logoutFunc() {
    this.authService.logOut();
  }


  public getName():string{

    return `${this.user.firstName} ${this.user.fammilyName}`;
  }

  public getRole():string{
    return UserRoleTypes[this.user.userRole].toString().replace('_',' ');
  }
}
